/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Time_Display_LabelInputs */

const fr_settings_time_display_label = /** @type {(inputs: Settings_Time_Display_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affichage de l'heure`)
};

const en_settings_time_display_label = /** @type {(inputs: Settings_Time_Display_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time display`)
};

/**
* | output |
* | --- |
* | "Time display" |
*
* @param {Settings_Time_Display_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_time_display_label = /** @type {((inputs?: Settings_Time_Display_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Time_Display_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_time_display_label(inputs)
	return en_settings_time_display_label(inputs)
});